/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 4c5208d9be66
 */

import * as z from "zod";
import {
  ResourceFieldsEnum,
  ResourceFieldsEnum$zodSchema,
} from "./resourcefieldsenum.js";

export type Fields = string | Array<ResourceFieldsEnum>;

export const Fields$zodSchema: z.ZodType<Fields> = z.union([
  z.string(),
  z.array(ResourceFieldsEnum$zodSchema),
]);
